var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStageCompletion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_346_647)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    className: "backgroundFill",
    d: "M130 70C130 103.137 103.137 130 70 130C36.8629 130 10 103.137 10 70C10 36.8629 36.8629 10 70 10C103.137 10 130 36.8629 130 70Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "colorChangeStroke",
    d: "M48.76 85.73H38.43C33.02 85.73 28.59 81.3 28.59 75.89V65.56C28.59 60.15 33.02 55.72 38.43 55.72H48.76C54.17 55.72 58.6 60.15 58.6 65.56V75.89C58.6 81.3 54.17 85.73 48.76 85.73V85.73Z",
    stroke: "#3F851E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "colorChange",
    d: "M41.2511 78.9868L53.75 66.7059L51.2502 64.25L41.2511 74.0751L36.2498 69.1617L33.75 71.6176L41.2511 78.9868Z",
    fill: "#3F851E"
  }), /*#__PURE__*/React.createElement("path", {
    className: "customFillElement",
    d: "M45.82 98.52C45.82 98.11 45.84 97.7 45.82 97.29C45.82 97 45.69 96.72 45.48 96.52C45.27 96.31 44.97 96.19 44.67 96.19C44.02 96.19 43.51 96.49 43.42 97.11C43.27 98.06 43.27 99.02 43.42 99.97C43.52 100.59 44.1 100.94 44.76 100.85C45.42 100.76 45.79 100.38 45.83 99.75C45.85 99.35 45.83 98.94 45.83 98.53L45.82 98.52Z",
    fill: "#273950"
  }), /*#__PURE__*/React.createElement("path", {
    className: "customFillElement",
    d: "M40.85 103.21C41.31 103.21 41.77 103.24 42.22 103.21C42.51 103.2 42.79 103.08 43 102.89C43.21 102.69 43.33 102.43 43.34 102.16C43.38 101.54 43.01 101.01 42.34 100.93C41.36 100.81 40.37 100.82 39.39 100.93C38.73 101.02 38.41 101.48 38.4 102.1C38.4 102.39 38.53 102.67 38.74 102.87C38.95 103.08 39.24 103.19 39.55 103.2C39.98 103.23 40.42 103.2 40.85 103.2V103.21Z",
    fill: "#273950"
  }), /*#__PURE__*/React.createElement("path", {
    className: "customFillElement",
    d: "M48.33 103.21C48.79 103.21 49.25 103.24 49.71 103.21C49.99 103.21 50.26 103.09 50.46 102.9C50.66 102.71 50.77 102.45 50.78 102.18C50.84 101.55 50.54 101.06 49.88 100.95C48.85 100.79 47.8 100.79 46.77 100.95C46.13 101.05 45.85 101.53 45.85 102.11C45.85 102.39 45.97 102.66 46.17 102.86C46.37 103.06 46.65 103.18 46.95 103.2C47.41 103.24 47.87 103.2 48.33 103.2V103.21Z",
    fill: "#273950"
  }), /*#__PURE__*/React.createElement("path", {
    className: "customFillElement",
    d: "M45.83 105.57C45.83 105.16 45.85 104.74 45.83 104.33C45.79 103.68 45.38 103.33 44.73 103.24C44.44 103.2 44.14 103.26 43.9 103.43C43.66 103.59 43.5 103.84 43.45 104.12C43.28 105.09 43.28 106.09 43.45 107.06C43.48 107.2 43.53 107.33 43.61 107.44C43.69 107.56 43.79 107.66 43.91 107.74C44.03 107.82 44.17 107.87 44.31 107.9C44.45 107.93 44.6 107.93 44.75 107.9C45.41 107.81 45.79 107.44 45.83 106.79C45.85 106.38 45.83 105.96 45.83 105.55V105.57Z",
    fill: "#273950"
  }), /*#__PURE__*/React.createElement("path", {
    className: "customFillElement",
    d: "M97.1 43.52C97.1 43.64 97.13 43.76 97.19 43.87C97.88 44.84 98.76 45.67 99.79 46.31C100.28 46.61 100.79 46.38 101.15 45.99C101.54 45.56 101.62 45.03 101.22 44.6C100.53 43.86 99.79 43.16 99.02 42.51C98.66 42.2 98.17 42.2 97.73 42.45C97.53 42.55 97.37 42.71 97.26 42.9C97.15 43.09 97.1 43.3 97.11 43.52H97.1Z",
    fill: "#273950"
  }), /*#__PURE__*/React.createElement("path", {
    className: "customFillElement",
    d: "M91.52 38.21C91.54 38.54 91.69 38.85 91.94 39.08C92.52 39.63 93.09 40.18 93.69 40.73C94.29 41.28 95.01 41.26 95.5 40.79C96 40.32 95.99 39.62 95.44 39.08C94.84 38.48 94.22 37.9 93.59 37.34C93.42 37.17 93.19 37.06 92.94 37.03C92.7 36.99 92.44 37.03 92.22 37.14C92 37.23 91.82 37.38 91.69 37.58C91.56 37.77 91.5 38 91.51 38.22L91.52 38.21Z",
    fill: "#273950"
  }), /*#__PURE__*/React.createElement("path", {
    className: "customFillElement",
    d: "M94.67 42.3C94.49 42.3 94.31 42.33 94.14 42.4C93.97 42.47 93.82 42.57 93.7 42.7C93.12 43.25 92.53 43.79 91.96 44.36C91.39 44.93 91.41 45.61 91.91 46.07C92.41 46.54 93.12 46.54 93.71 46C94.3 45.46 94.91 44.88 95.5 44.3C95.69 44.13 95.81 43.91 95.85 43.67C95.89 43.43 95.85 43.18 95.74 42.97C95.65 42.77 95.5 42.6 95.31 42.47C95.12 42.35 94.89 42.29 94.66 42.29L94.67 42.3Z",
    fill: "#273950"
  }), /*#__PURE__*/React.createElement("path", {
    className: "customFillElement",
    d: "M97.13 39.96C97.13 40.18 97.2 40.39 97.33 40.57C97.46 40.75 97.64 40.9 97.85 40.99C98.3 41.17 98.78 41.17 99.14 40.85C99.85 40.24 100.53 39.59 101.17 38.91C101.61 38.44 101.55 37.89 101.11 37.42C100.72 37 99.98 36.87 99.54 37.25C98.76 37.9 98.05 38.61 97.34 39.32C97.26 39.41 97.2 39.51 97.17 39.62C97.13 39.73 97.12 39.85 97.14 39.96H97.13Z",
    fill: "#273950"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "customFillElement",
    x: 68,
    y: 59,
    width: 46,
    height: 4,
    rx: 2,
    fill: "#273950"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "customFillElement",
    x: 68,
    y: 68,
    width: 46,
    height: 4,
    rx: 2,
    fill: "#273950"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "customFillElement",
    x: 68,
    y: 78,
    width: 46,
    height: 4,
    rx: 2,
    fill: "#273950"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_346_647",
    x: 2,
    y: 2,
    width: 136,
    height: 136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.666667 0 0 0 0 0.666667 0 0 0 0 0.666667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_346_647"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_346_647",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStageCompletion);
export default __webpack_public_path__ + "static/media/stageCompletion.1cd2edd507193de78a494b79db1a3489.svg";
export { ForwardRef as ReactComponent };